export default "__VITE_ASSET__DLzka5zJ__"